module.exports = __webpack_public_path__ + "static/media/fig_19.7365cb80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_19.jpg
// module id = 649
// module chunks = 0